// Replaces the PDP price and Add to cart / Buy now button price with the
// monthly amount rendered by the Affirm "Pay-over-time Messaging" app block,
// once that widget has actually rendered a "$XX/mo" amount.
// If the Affirm block isn't present, or hasn't rendered an amount yet, this does nothing.

(function () {
  var AFFIRM_MONTHLY_REGEX = /\$\s?([\d,]+(?:\.\d{1,2})?)\s*\/\s*mo/i;

  function extractMonthlyText(affirmBlock) {
    var match = affirmBlock.textContent.match(AFFIRM_MONTHLY_REGEX);
    return match ? '$' + match[1] + '/mo' : null;
  }

  function isAffirmText(text) {
    return AFFIRM_MONTHLY_REGEX.test(text);
  }

  function syncPriceBlock(root, monthlyText) {
    var priceEl = root.querySelector('.price');
    if (!priceEl) return;

    var saleContainer = priceEl.querySelector('.price__sale');
    if (!saleContainer) return;

    var saleItem = saleContainer.querySelector('.price-item--sale');
    if (!saleItem || isAffirmText(saleItem.textContent)) return;

    var originalPriceText = saleItem.textContent.trim();
    saleItem.textContent = monthlyText;

    var compareEl = saleContainer.querySelector('s.price-item--regular');
    if (!compareEl) {
      var wrapper = document.createElement('span');
      compareEl = document.createElement('s');
      compareEl.className = 'price-item--regular';
      wrapper.appendChild(compareEl);
      saleItem.insertAdjacentElement('afterend', wrapper);
    }
    compareEl.textContent = originalPriceText;
  }

  function syncButtons(root, monthlyText) {
    root.querySelectorAll('.product-form__submit').forEach(function (btn) {
      // Templates with buy_buttons.show_price_in_btn enabled already render this span.
      var priceSpan = btn.querySelector('.compare_at_pricein_btn');
      if (priceSpan) {
        if (!isAffirmText(priceSpan.textContent)) priceSpan.textContent = monthlyText;
        return;
      }

      // Most templates don't render a price inside the button at all, so fall back
      // to appending a matching .compare_at_pricein_btn span (same class the "•"
      // separator in section-main-product.css already targets) onto the button's label.
      var label = btn.querySelector('span');
      if (!label) return;

      var text = label.textContent.trim();
      if (!text || /sold out/i.test(text) || text.indexOf('$') !== -1) return;

      priceSpan = document.createElement('span');
      priceSpan.className = 'compare_at_pricein_btn';
      priceSpan.textContent = monthlyText;
      label.appendChild(priceSpan);
    });
  }

  function reconcile(root, affirmBlock) {
    var monthlyText = extractMonthlyText(affirmBlock);
    if (!monthlyText) return;

    syncPriceBlock(root, monthlyText);
    syncButtons(root, monthlyText);
  }

  function init(root) {
    var affirmBlock = root.querySelector('.shopify-app-block');
    if (!affirmBlock) return;

    var reconcileNow = function () {
      reconcile(root, affirmBlock);
    };

    new MutationObserver(reconcileNow).observe(affirmBlock, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    var priceEl = root.querySelector('.price');
    if (priceEl) {
      new MutationObserver(reconcileNow).observe(priceEl, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        setTimeout(reconcileNow, 50);
      });
    }

    reconcileNow();
  }

  var booted = false;

  function boot() {
    if (booted) return true;
    if (!(window?.ab_enabled && window?.ab_affirm)) return false;
    booted = true;
    document.querySelectorAll('.product__info-container').forEach(init);
    return true;
  }

  // window.ab_enabled / window.ab_affirm are set by an external AB-testing
  // script and may not be ready yet at DOMContentLoaded, so keep checking
  // for a while instead of gating once and giving up.
  function pollForFlags() {
    var attempts = 0;
    var maxAttempts = 40; // ~10s at 250ms
    var intervalId = setInterval(function () {
      attempts++;
      if (boot() || attempts >= maxAttempts) {
        clearInterval(intervalId);
      }
    }, 250);
  }

  function start() {
    if (!boot()) pollForFlags();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
